import {
  ScrollspyV2Nav,
  ScrollspyV2NavItem,
  ScrollspyV2ScrollView,
  ScrollspyV2Target,
} from './components';

// ─────────────────────────────────────────────────────────────────────────────

export const ScrollspyV2 = {
  ScrollView: ScrollspyV2ScrollView,
  Target: ScrollspyV2Target,
  Nav: ScrollspyV2Nav,
  NavItem: ScrollspyV2NavItem,
};
